<template>
  <div>
    <header-component position-relation></header-component>
    <div class="body-max-container">
      <div class="user-container">
        <div class="box user-box">
          <div class="user-body">
            <h3 class="title">會員資料</h3>
            <!--
            <h4 class="sub-title">
              還沒加入會員？<br />
              歡迎註冊和關心動物互動，下載更多教案、圖文素材。
            </h4>
            -->
            <el-form label-position="left" label-width="100px" :model="memberModel">
              <el-form-item label="暱稱">
                <span class="sub-title">{{ memberModel.nickName }}</span>
              </el-form-item>
              <el-form-item label="姓名">
                <span class="sub-title">{{ memberModel.firstName + " " + memberModel.lastName }}</span>
              </el-form-item>
              <el-form-item label="信箱">
                <span class="sub-title">{{ memberModel.email }}</span>
              </el-form-item>
              <el-form-item v-if="memberModel.emailVerifiedTime === null" label="信箱認證">
                <el-col :span="16">
                  <el-input class="email-verify-input" v-model="verifyCodeInput" placeholder="輸入六位數認證碼"></el-input>
                </el-col>
                <el-col :span="8">
                  <el-button class="send-btn" @click="handleEmailVerify">
                    送出認證
                  </el-button>
                </el-col>
              </el-form-item>
              <el-form-item label="身份">
                <span class="sub-title">{{ memberModel.role }}</span>
              </el-form-item>
              <el-form-item label="生理性別">
                <span class="sub-title">{{ memberModel.sex }}</span>
              </el-form-item>
              <el-form-item label="生日">
                <span class="sub-title">{{ memberModel.birthday }}</span>
              </el-form-item>
              <el-form-item label="電子報">
                <el-button class="send-btn" @click="handleSubscription">
                  {{ memberModel.subscription ? '取消訂閱' : '訂閱'}}
                </el-button>
              </el-form-item>
              <el-form-item label="">
                <el-button class="send-btn" @click="handleLogout">
                  登出
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import FooterComponent from "../components/FooterComponent";
import { MemberModel } from "@/models/member-model";
import { info, subscribe, unsubscribe } from "@/apis/member";
import { ResponseModel } from "@/models/response-model";
import IndexMixin from "@/mixins/index-mixin";

export default {
  name: "Login",
  mixins: [IndexMixin],
  components: { FooterComponent, HeaderComponent },
  computed: {
    getDateYear() {
      const nowYear = new Date().getFullYear();
      const years = [];
      for (let i = 0; i < 100; i++) {
        years.push(nowYear - i);
      }
      return years;
    },
    isEnableMonth() {
      console.log(this.memberModel.birthdayYear)
      console.log(isNaN(this.memberModel.birthdayYear))
      return isNaN(this.memberModel.birthdayYear);
    },
    getDateMonth() {
      const months = [];
      if (this.isEnableMonth) {
        for (let i = 0; i <= 11; i++) {
          months.push(i);
        }
      }
      return months;
    },
    isEnableDay() {
      return isNaN(this.memberModel.birthdayMonth);
    },
    isLeap() {
      const year = this.memberModel.birthdayYear;
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    },
    getDateDay() {
      const days = [];
      let dayCount = 0;
      if (this.isEnableDay && this.memberModel.birthdayMonth !== 1) {
        dayCount =
          new Date(
            this.memberModel.birthdayYear,
            this.memberModel.birthdayMonth,
            0
          ).getDate() + 1;
      } else if (this.memberModel.birthdayMonth === 1) {
        dayCount = this.isLeap ? 29 : 28;
      }
      for (let i = 0; i < dayCount; i++) {
        days.push(i);
      }
      return days;
    },
  },
  data() {
    return {
      memberModel: new MemberModel(),
      verifyCodeInput: null
    };
  },
  created() {
    window.scroll(0, 0)
  },
  mounted() {
    this.openLoading()
    info().then(res => {
      this.closeLoading()
      const response = new ResponseModel(res)
      if (response.isSuccess) {
        this.memberModel = new MemberModel(response.result)
      }
      console.log(res)
    }).catch(e => {
      console.log(e)
      this.closeLoading()
      this.$12nightsAlert({
        title: "提示",
        message: "請重新登入"
      }).then(() => {
        this.$router.push({
          name: "Login"
        })
      })
    })
  },
  methods: {
    handleEmailVerify() {
    },
    handleSubscription() {
      if (this.memberModel.subscription) {
        this.$12nightsConfirm({
          title: "提示",
          message: "確定要取消訂閱？"
        }).then(() => {
          this.openLoading()
          unsubscribe().then(res => {
            this.closeLoading()
            const response = new ResponseModel(res)
            if (response.isSuccess) {
              this.memberModel = new MemberModel(response.result)
            }
          }).catch(e => {
            console.log(e)
            this.closeLoading()
            this.$12nightsAlert({
              title: "提示",
              message: "請重新登入"
            }).then(() => {
              this.$router.push({
                name: "Login"
              })
            })
          })
        })
      } else {
        this.openLoading()
        subscribe().then(res => {
          this.closeLoading()
          const response = new ResponseModel(res)
          if (response.isSuccess) {
            this.memberModel = new MemberModel(response.result)
          }
        }).catch(e => {
          console.log(e)
          this.closeLoading()
          this.$12nightsAlert({
            title: "提示",
            message: "請重新登入"
          }).then(() => {
            this.$router.push({
              name: "Login"
            })
          })
        })
      }
    },
    handleLogout() {
      this.$store.dispatch("member/logout")
      this.$router.push({
        name: "Login"
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.option-select {
  .el-input {
    margin-top: 0;
  }
  .el-input .el-input__inner {
    border: 0;
    border-radius: 5px;
    text-align: center;
  }
}
</style>
